module.exports = __webpack_public_path__ + "img/feature-bookmark.f70a95a3.png";